import reducers from './reducers';

// Named exports for types, selectors, and operations
export { default as productsTypes } from './types';
export { default as productsSelectors } from './selectors';
export { default as productsOperations } from './operations';

// Default export is the reducers
export default reducers;
